import { useContext, useEffect, useState } from 'react';

import { QualificationContext } from 'pages/leads/components/qualification-context';
import { RevenueProps } from 'pages/leads/pages/revenues/revenues-page.types';
import { Trans, useTranslation } from 'react-i18next';

import { ChevronDownOutline } from '@olist/design-system-icons';
import { Box } from '@olist/united';

import { CustomSelect } from '../../revenues-container/revenues-container.style';
import { Wrapper } from './revenue-dropdown.style';

interface RevenenuesDropdown {
  onChangerRevenues: (revenue: RevenueProps) => void;
}

const RevenuesDropdown = ({ onChangerRevenues }: RevenenuesDropdown) => {
  const { t } = useTranslation();

  const [selectedSegment, setSelectedSegment] = useState<string>('');
  const { revenues } = useContext(QualificationContext);

  useEffect(() => {
    const checkedSegments = revenues.find((option: RevenueProps) => option?.id === selectedSegment);

    onChangerRevenues(checkedSegments);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revenues, selectedSegment]);

  const handleChangeRevenue = (id: string) => {
    setSelectedSegment(id);
  };

  return (
    <Wrapper>
      <Box mb={4}>
        <Trans i18nKey="sumInvoice">
          Invoicing <b>is the sum total of the values obtained through the sales of products</b> in
          a given period.
        </Trans>
      </Box>

      <Box mt={1}>
        <CustomSelect>
          <select
            data-testid="revenue-select"
            required
            name="reveunue"
            id="requisites-revenue"
            value={selectedSegment}
            onChange={(e) => {
              handleChangeRevenue(e.target.value);
            }}
          >
            <option value="" className="empty-option">
              {t`select billing in reais`}
            </option>
            {revenues.map((opt: RevenueProps) => {
              if (opt.range !== `prefiro não informar`) {
                return (
                  <option key={opt.id} value={opt.id} data-testid={opt.id}>
                    {opt.range.toLowerCase()}
                  </option>
                );
              }

              return null;
            })}
          </select>
          <ChevronDownOutline width={24} height={24} color="#696d8c" />
        </CustomSelect>
      </Box>
    </Wrapper>
  );
};

export default RevenuesDropdown;
